import { useState, useEffect, useCallback } from 'react';

/**
 * Hook to manage the Command Palette state and keyboard shortcuts
 * - Cmd+K (Mac) / Ctrl+K (Windows/Linux) to open
 * - Escape to close
 */
const useCommandPalette = () => {
    const [isOpen, setIsOpen] = useState(false);

    const open = useCallback(() => {
        setIsOpen(true);
    }, []);

    const close = useCallback(() => {
        setIsOpen(false);
    }, []);

    const toggle = useCallback(() => {
        setIsOpen(prev => !prev);
    }, []);

    // Listen for keyboard shortcuts
    useEffect(() => {
        const handleKeyDown = (e) => {
            // Cmd+K (Mac) or Ctrl+K (Windows/Linux)
            if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
                e.preventDefault();
                toggle();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [toggle]);

    // Prevent body scroll when palette is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpen]);

    return {
        isOpen,
        open,
        close,
        toggle
    };
};

export default useCommandPalette;
